var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBlackPencilIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#0d0d0d",
    d: "M14.487 1.512a1.75 1.75 0 0 0-2.474 0l-.772.772 2.475 2.474.771-.77a1.75 1.75 0 0 0 0-2.476M13.01 5.466 10.534 2.99l-8.1 8.1a3.5 3.5 0 0 0-.88 1.476l-.533 1.79a.5.5 0 0 0 .622.622l1.79-.533a3.5 3.5 0 0 0 1.476-.88z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlackPencilIcon);
export default __webpack_public_path__ + "static/media/black_pencil_icon.7c6fc4c08cc81090ffc55489d39dd192.svg";
export { ForwardRef as ReactComponent };